import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../store/authSlice";
import FuelMonitoringPage from "../components/fuel/FuelMonitoringPage";
import GlobalDashboardSidebar from "../components/admin/GlobalDashboardSidebar";
import useGlobalSidebarItems from "../components/admin/useGlobalSidebar";
import "../components/admin/admindashboard.css";
import "../components/admin/dashboard-redesign.css";

// Fuel monitoring has its own screen. Keeping it outside the generic dashboard
// tab renderer prevents the assignments/quick-actions page from being shown
// when a browser restores an older dashboard URL.
export default function FuelMonitoringRoutePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.auth.user);
  const sidebarItems = useGlobalSidebarItems();

  const roleLabel = useMemo(() => {
    const value = String(currentUser?.role || "User").replace(/_/g, " ");
    return value.replace(/\b\w/g, (letter) => letter.toUpperCase());
  }, [currentUser?.role]);

  return (
    <div className="dashboard-page-shell admin-dashboard-shell has-global-sidebar">
      <GlobalDashboardSidebar
        items={sidebarItems}
        profileName={currentUser?.username || "User"}
        roleLabel={roleLabel}
        onSupport={() => navigate("/message")}
        onLogout={() => dispatch(logout())}
      />
      <main className="dashboard-content admin-dashboard-shell__content">
        <div className="ad-main-content admin-dashboard-shell__main standard-shell">
          <div className="ad-tab-container admin-dashboard-shell__tab-container standard-shell">
            <FuelMonitoringPage />
          </div>
        </div>
      </main>
    </div>
  );
}
